/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener('click', function(event) {
  const button = event.target.closest('.radio__button');
  if (button) {
    const productBlock = document.querySelectorAll('.choice__color');
    if (button.classList.contains('packed-option')) {
      productBlock.forEach(el => el.style.display = 'block');
    } else {
      productBlock.forEach(el => el.style.display = 'none');
    }
  }
});
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



function initPersonalisation(context = document) {
  const personalisationBlock = context.querySelector('.personalisation__product_block');
  const radios = context.querySelectorAll('.personalisation__variant input[type="radio"]');
  const inputField = context.querySelector('.personalisation-inputField');
  const labelSpan = context.querySelector('.form__label.custom span');
  if (!personalisationBlock) return;
  function togglePersonalisation() {
    const checkedRadio = context.querySelector('.personalisation__variant input[type="radio"]:checked');
    if (checkedRadio && checkedRadio.value === 'Yes') {
      personalisationBlock.style.display = 'block';
    } else {
      personalisationBlock.style.display = 'none';
      if (inputField) inputField.value = '';
      if (labelSpan) labelSpan.textContent = '0 - 7';
    }
  }
  togglePersonalisation();
  radios.forEach(radio => {
    radio.addEventListener('change', togglePersonalisation);
  });
  if (inputField && labelSpan) {
    inputField.addEventListener('input', e => {
      labelSpan.textContent = e.target.value.length + ' - 7';
    });
  }
}
document.addEventListener('DOMContentLoaded', function () {
  initPersonalisation(document);
});
document.addEventListener('input', function (e) {
  if (!e.target.classList.contains('personalisation-inputField')) return;
  const value = e.target.value;
  const container = e.target.closest('form, .product-quick-add__inner, .product');
  if (!container) return;
  const targetInput = container.querySelector('.collectionPage_property');
  if (!targetInput) return;
  targetInput.value = value;
});
document.addEventListener(
  'click',
  function (e) {
    const btn = e.target.closest('[data-quick-add-btn]');
    if (!btn) return;
    setTimeout(() => {
      document
        .querySelectorAll('.product-quick-add__inner')
        .forEach(container => initPersonalisation(container));
    }, 1000);
  },
  true
);